import React, { useMemo, Suspense } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { Box, Flex } from "@chakra-ui/react";
import Sidebar from "../../components/Sidebar";
import { SplashScreen } from "../../components/Loader";
import ChangePassword from "../app/setting/change-password";
import { useAuth } from "../../plugins/CookieAuthPlugin";
import { MenuConstants } from "../../constants/menu";

const DelayImport = (path) => {
  return React.lazy(() => {
    return Promise.all([path, new Promise((resolve) => setTimeout(resolve, 300))]).then(([moduleExports]) => moduleExports);
  });
};

//request
const Question = DelayImport(import("./request/question"));
const ReadinessQuestion = DelayImport(import("./request/readiness-question"));
const Form = DelayImport(import("./request/form"));

//setting
const Reason = DelayImport(import("./setting/reason"));
const FormGroup = DelayImport(import("./setting/form-group"));
const Zone = DelayImport(import("./setting/zone"));
const Company = DelayImport(import("../app/setting/company"));
const User = DelayImport(import("../app/setting/user"));
const SystemRole = DelayImport(import("../app/setting/system-role"));
const Department = DelayImport(import("../app/setting/department"));

//report
const Report = DelayImport(import("./report/report"));

const routeItem = [
  // Request Menu
  { path: "/form", component: <Form /> },
  { path: "/question", component: <Question /> },
  { path: "/readiness-question", component: <ReadinessQuestion /> },

  // Report Menu
  { path: "/report", component: <Report /> },

  // Setting Menu
  { path: "/reason", component: <Reason /> },
  { path: "/form-group", component: <FormGroup /> },
  { path: "/zone", component: <Zone /> },
  { path: "/company", component: <Company /> },
  { path: "/user", component: <User /> },
  { path: "/system-role", component: <SystemRole /> },
  { path: "/department", component: <Department /> },
  { path: "/change-password", component: <ChangePassword /> },
];

const MotionBox = motion(Box);
export default function App() {
  const { user } = useAuth();
  const location = useLocation();
  const redirectURL = useMemo(() => {
    if (user.menuPermission) {
      return MenuConstants.reduce((acc, { item }) => [...acc, ...item], []).find(({ id }) => user.menuPermission[id] && user.menuPermission[id]["VIEW"])?.id;
    }
  }, [user.menuPermission]);

  return (
    <Suspense fallback={<SplashScreen />}>
      <Flex position="relative" h="100vh" overflow="auto" id="app-container">
        <Box display="flex" hidden={user?.statusLogin === 1}>
          <Sidebar />
        </Box>
        <Box w={"calc(100% - 18rem)"} p="2" position="relative" flex="1">
          <AnimatePresence exitBeforeEnter>
            <Switch location={location} key={location.pathname}>
              {routeItem.map(({ path, component }) => {
                // super admin can't change password
                if (path === "/change-password" && (user.username === "udaya" || user.id === 7)) return <Redirect to="/" />;
                return (
                  <Route key={path} path={path}>
                    <MotionBox h="full" overflow="auto" rounded="md" key={location.pathname} initial={{ y: -10, opacity: 0, transition: { duration: 0.15 } }} animate={{ y: 0, opacity: 1, transition: { duration: 0.2 } }} exit={{ y: -20, opacity: 0, transition: { duration: 0.15 } }}>
                      {component}
                    </MotionBox>
                  </Route>
                );
              })}
              {!!redirectURL ? <Redirect to={`/${redirectURL}`} /> : <Redirect to={`/`} />}
            </Switch>
          </AnimatePresence>
        </Box>
      </Flex>
    </Suspense>
  );
}
